var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "c-illustration-container" },
    [
      _vm.illustrationIds[0] === false
        ? _c(
            "transition",
            { attrs: { name: "section-fade", mode: "out-in" } },
            [_c("MissingImage", [_vm._v("Bilde mangler")])],
            1
          )
        : _c(
            "transition",
            { attrs: { name: "section-fade", mode: "out-in" } },
            [
              _vm.activeIllustrationId
                ? _c("selector-illustration", {
                    attrs: { illustrationId: _vm.activeIllustrationId },
                  })
                : _vm._e(),
            ],
            1
          ),
      _vm._v(" "),
      _vm.illustrationIds.length > 1
        ? _c("illustration-navigation", {
            attrs: { illustrationIds: _vm.illustrationIds },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.illustrationIds.length > 1
        ? _c("selector-thumbnails", {
            attrs: { illustrationIds: _vm.illustrationIds },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }